import { render, staticRenderFns } from "./updateCaseTeam.vue?vue&type=template&id=3247525b&scoped=true&"
import script from "./updateCaseTeam.vue?vue&type=script&lang=js&"
export * from "./updateCaseTeam.vue?vue&type=script&lang=js&"
import style0 from "./updateCaseTeam.vue?vue&type=style&index=0&id=3247525b&prod&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "3247525b",
  null
  
)

export default component.exports